import router from "@/routes";
import { isTokenExpired } from "@/utils/common";
import axios from "axios";

export const API = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: "*/*",
  },
});

API.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    if (isTokenExpired(token)){
      router.push('/login');
      return Promise.reject(new Error("Token expired"));
    }
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (resposne) => resposne,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push("/login");
      } else {
        router.push("/error");
      }
    }
    return Promise.reject(error);
  }
);
